import { InjectionToken } from '@angular/core';
import { MeterRow, MeterSensorType } from './meter-row.types';

export type MeterDecimalFormat = {
  minIntegerDigits?: number;
  minFractionDigits?: number;
  maxFractionDigits?: number;
};

export type MeterColumnType =
  | 'text'
  | 'number'
  | 'datetime'
  | 'status'
  | 'link'
  | 'action';

export type MeterColumn = {
  key: string;
  label: string;
  field?: keyof MeterRow | string;
  type?: MeterColumnType;
  sortable?: boolean;
  visible?: boolean;
  exportable?: boolean;
  widthClass?: string;
  order?: number;
  decimal?: MeterDecimalFormat;
  sensorTypes?: MeterSensorType[];
  valueGetter?: (
    row: MeterRow,
    index: number,
    pageIndex: number,
    pageSize: number,
  ) => unknown;
};
export type ModuleColumns = Record<string, MeterColumn[]>;

export type MeterColumnConfig = {
  energy?: ModuleColumns;
  water?: MeterColumn[];
};

export const METER_COLUMNS = new InjectionToken<MeterColumnConfig>(
  'METER_COLUMNS',
);
